/* eslint-disable react/prop-types,react/no-array-index-key,react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  selectRequestState,
  selectItemsIds,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';
import { t } from 'utils/translates';

import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';

import {
  changeServiceArgs,
  sendRequest as sendRequestSetRead
} from 'mt-react-common/modules/events/common/reducers/userNoticesSetReadForm';

import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import OpacityPreLoader from '../../../../components/Common/PreLoaders/OpacityPreLoader';

const eventsNotReadUserNoticesListRN =
  'eventsModule.lists.eventsNotReadUserNoticesList';
const eventsUserNoticesCollectionRN =
  'eventsModule.collections.eventsUserNoticesCollection';
const userNoticesSetReadFormRN = 'eventsModule.forms.userNoticesSetReadForm';

class NotificationsDrop extends Component {
  constructor(props) {
    super(props);
    this.dropDownBlock = React.createRef();
    this.props.sendRequest();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = e => {
    if (!this.dropDownBlock.current.contains(e.target)) {
      this.props.closeDropdown();
    }
  };

  handleSetReadNotice = (e, notice) => {
    e.preventDefault();
    if (notice.noticeAppStatus === 1) {
      this.props.changeServiceArgs([notice.id]);
      this.props.sendRequestSetRead();
    }
  };

  noticeView = noticeId => {
    this.context.router.history.push(`/notifications/view/${noticeId}`);
    this.props.closeDropdown();
  };

  render() {
    let noticesList;
    if (this.props.itemsIds.length > 0) {
      noticesList = this.props.itemsIds.map(index => {
        const item = this.props.selectItemById(index);
        return (
          <div
            key={index}
            className="dropdown-menu-alert"
            style={
              item.noticeAppStatus === 1
                ? {
                    background: '#fffddd'
                  }
                : {}
            }
            role="none"
            onMouseEnter={e => this.handleSetReadNotice(e, item)}
            onClick={() => this.noticeView(index)}
          >
            <div className="media">
              <div className="media-left">
                <div className="avatar avatar-icon avatar-icon-sm avatar-icon-primary">
                  <i className="fa fa-star fa-lg" />
                </div>
              </div>
              <div className="media-body media-middle">
                <div className="media-info">
                  <span className="media-info-name">{`${item.typeTitle} `}</span>
                  <span className="media-info-desc">
                    {item.createdAtFormatted}
                  </span>
                </div>
                <div>{item.message}</div>
              </div>
            </div>
          </div>
        );
      });
    } else {
      noticesList = (
        <div className="dropdown-menu-alert-empty">
          {t('Нет новых уведомлений')}
        </div>
      );
    }

    return (
      <div
        className="dropdown-menu dropdown-menu-notify"
        id="notification"
        ref={this.dropDownBlock}
      >
        <div className="dropdown-menu-header text-center">
          <h4>{t('Уведомления')}</h4>
        </div>
        <div className="dropdown-menu-body">
          {this.props.requestState.inProgress ? <OpacityPreLoader /> : null}
          {noticesList}
        </div>
        <NavLink
          to="/notifications"
          className="dropdown-menu-footer text-center"
          onClick={() => this.props.closeDropdown()}
        >
          {t('Показать все')}
        </NavLink>
      </div>
    );
  }
}

NotificationsDrop.contextTypes = {
  router: PropTypes.shape()
};

NotificationsDrop.propTypes = {
  closeDropdown: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  sendRequestSetRead: PropTypes.func.isRequired,
  changeServiceArgs: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, eventsNotReadUserNoticesListRN),
  itemsIds: selectItemsIds(state, eventsNotReadUserNoticesListRN),
  selectItemById: id => selectItemById(state, eventsUserNoticesCollectionRN, id)
});

const mapDispatchToProps = dispatch => ({
  sendRequest: () => dispatch(sendRequest(eventsNotReadUserNoticesListRN)),
  changeServiceArgs: value =>
    dispatch(changeServiceArgs(userNoticesSetReadFormRN, value)),
  sendRequestSetRead: () =>
    dispatch(sendRequestSetRead(userNoticesSetReadFormRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsDrop);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Header/Notifications/NotificationsDrop.js